import React from 'react';
import PropTypes from 'prop-types';
import AIcon from '../atoms/_atoms.icon';

export default function MIndicators({ value, amount, className }) {
	const list = [];
	const createList = ({ index }) => {
		const cName = index === value ? 'active' : '';

		return (
			<li key={index}>
				<AIcon type="indicator" className={cName} />
			</li>
		);
	};

	for (let i = 0; i < amount; i++) {
		list.push(createList({ index: i }));
	}

	return (
		<ul className={`m-indicators ${className}`}>
			{list}
		</ul>
	);
}

MIndicators.propTypes = {
	amount: PropTypes.number.isRequired,
	value: PropTypes.number,
	className: PropTypes.string,
};

MIndicators.defaultProps = {
	value: 0,
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.indicators.js